import _TabEnabledMixin from '../Tabbing/_TabEnabledMixin';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './_KanbanHubBase.html?raw';
import type { SortableEvent } from "sortablejs";
import { KanbanTypes } from "./KanbanTypes";
import Button from '../Button/Button';
import "../Button/Button";
import Kanban from './Kanban';
import FilterPanel from '../FilterPanel/FilterPanel';
import { FilterPanelTypes as FilterPanelTypes } from "../../_loadingHelpers/Filterpanel";
import { ToasterHelpers, TranslationHelpers } from "../../../more/Helpers";



interface KanbanHubConfigResponse {
    filterpanel: FilterPanelTypes.PanelConfig
}

interface KanbanHubConfig<T> {
    filterpanelAPI?: string,
    additionalRequestData?: any,
    kanbanConfigAPI: string,
    elementDetailsClick?: KanbanTypes.ElementClickCallback<T>,
    infoContentAPI?: string, //KanbanTypes.ElementClickCallback,
    //infoContentPromise: Promise<KanbanTypes.InfoContentData>,
    //dataChangeCallback?: KanbanTypes.DataChangeCallback
    elementEditClick?: KanbanTypes.ElementClickCallback,
    editBtnEnabledCallback?: KanbanTypes.EnableBtnCallback,
    deleteBtnEnabledCallback?: KanbanTypes.EnableBtnCallback,
    changeSaveAPI?: string,
    readonly?: boolean
}

interface ButtonConfig {
    callback: (evt: PointerEvent) => any,
    label: string,
    iconClass?: string,
    enabled: boolean | (() => boolean) | "syncToReload" | "syncToSubmit"
}
class _KanbanHubBase<T> extends compose(_TabEnabledMixin) {
    templateString: any = template;

    private _hubConfig: KanbanHubConfig<T> = null;

    /* HTML Points */
    private noResultsContainer: HTMLElement;
    private btnSubmit: MdsLax<InstanceType<typeof Button>>;
    private btnReload: MdsLax<InstanceType<typeof Button>>;
    private kanbanContainer: HTMLDivElement;
    private filterPanelContainer: HTMLDivElement;
    private sectionFilterPanel: HTMLDivElement;
    private sectionKanbanContainer: HTMLDivElement;

    private _mainButtonsContainer: HTMLElement;

    private _customButtonsReg: Record<string, {
        button: MdsLax<InstanceType<typeof Button>>,
        overrideEnable?: boolean,
        config: ButtonConfig
    }>;

    private readonly: boolean = false;

    private _filterPanel: MdsLax<InstanceType<typeof FilterPanel>>;
    protected _kanban: MdsLax<InstanceType<typeof Kanban>>;

    private _setResult(data: {
        dashboards: KanbanTypes.DashboardConfig[],
        columns: KanbanTypes.ColumnConfig[]
    }) {
        let kanban = new Kanban();
        kanban.placeAt(this.kanbanContainer);
        kanban.setup({
            dataPoolWidth: "200px",
            infoColumnWidth: "300px",
            columns: data.columns,
            dashboards: data.dashboards,
            dataChangeCallback: lang.hitch(this, this._onChange_KanbanData),
            showDetailsCallback: lang.hitch(this, this._detailsCallback)
        });
    }

    private _detailsCallback(data){
        console.log(this.id + " _detailsCallback", data);
    }

    private _currentChangeData: EntityStoreData<any>;
    private _onChange_KanbanData(changeData: EntityStoreData<any>) {

        console.log(this.id + " _onChange_KanbanData", changeData);

        this._showChangesToast(changeData);
    }

    private _showChangesToast(newChangeData?: EntityStoreData<any>) {

        if (this.readonly) newChangeData = null;

        if (typeof (newChangeData) != "undefined") {
            this._currentChangeData = newChangeData;
        } else {
            newChangeData = this._currentChangeData;
        }

        if (!newChangeData) {

            this._removeChangesToast();
            return;
        }

        ToasterHelpers.showToast({
            ID: this.id + "_kanbanChangeData",
            title: TranslationHelpers.translate("General_PendingChanges") + ": " + (newChangeData.changed.length + newChangeData.deleted.length + newChangeData.new.length).toString(),
            options: {
                timeout: "permanent",
                buttons: [{
                    callback: lang.hitch(this, this._onClick_SaveChanges),
                    label: "",
                    icon: toasterIcons.save
                }, {
                    callback: lang.hitch(this, this._onClick_UndoChanges),
                    label: "",
                    icon: toasterIcons.undo
                }]
            }

        })

    }

    private _removeChangesToast() {
        ToasterHelpers.removeToast(this.id + "_kanbanChangeData");
    }

    private _onClick_SaveChanges(evt: MouseEvent) {
        if (this.readonly) return;

        this._saveChanges();
    }

    private _saveChanges() {
        this.StandbyStart();

        this.removeToast(this.id + "_savingFailed");

        let data = this._currentChangeData;

        this.RequestManager.callfunction(
            this._hubConfig.changeSaveAPI,
            data,
            lang.hitch(this, this._onSaveChangesResponse),
            lang.hitch(this, this._onSaveChangesError),
            true
        );
    }

    private _onClick_UndoChanges(evt: MouseEvent) {
        this._showChangesToast(null);

        this.setupKanban(this._previousKanbanConfig);
    }

    private _onSaveChangesResponse(response?: KanbanTypes.MainConfig) {
        this.StandbyStop();

        if (response) {
            if (response.dashboards) {
                this.setupKanban(response);
            } else {
                // nur success-Meldung? selber neu laden
                this.loadKanbanConfig();
            }
        }
    }

    private _onSaveChangesError(error: more.requestErrorMessage) {
        ToasterHelpers.showToast({
            title: "General_SavingFailed",
            ID: this.id + "_savingFailed",
            timeout: "permanent",
            message: error.Message,
            iconClass: toasterIcons.error
        });

        this._showChangesToast();

        this.StandbyStop();
    }

    protected setup(config: KanbanHubConfig<T>) {
        this._hubConfig = config;
        
        if (this._hubConfig.filterpanelAPI) {
            this.loadFilterpanelConfig();
        } else {
            this.loadKanbanConfig();
        }
    }

    protected setElementData(element: KanbanTypes.DataElement<T>, newData: T) {
        this._kanban.changeDataElement(element, newData);
    }
    private filterpanelRequest: dojo.request.Promise<any> = null;
    private loadFilterpanelConfig() {
        if (this._hubConfig.filterpanelAPI) {
            let data = {};
            if (this._hubConfig.additionalRequestData) {
                if (typeof (this._hubConfig.additionalRequestData) == "object") {
                    data = { ...this._hubConfig.additionalRequestData };
                }
            }

            this.StandbyStart();

            this.filterpanelRequest = this.RequestManager.callfunction(
                this._hubConfig.filterpanelAPI,
                data,
                lang.hitch(this, this._onLoadFilterpanelConfigResponse),
                lang.hitch(this, this._onLoadFilterpanelConfigError)
            );
        }
    }
    private _onLoadFilterpanelConfigError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);
    }
    private _onLoadFilterpanelConfigResponse(response: KanbanHubConfigResponse) {
        this.StandbyStop();

        if (response?.filterpanel) {
            this._filterPanel = new FilterPanel();
            this._filterPanel.placeAt(this.filterPanelContainer, "only");
            
            this.btnSubmit.show();
            this.hideNode(this.sectionFilterPanel, false);

            this._filterPanel.setConfig(response.filterpanel, lang.hitch(this, this._onChange_Filterpanel));

        }else {
            this.loadKanbanConfig();
        }


    }
    private _undirtyDataStr: string = "-x";
    protected _currentFilterPanelData: any;
    private _onChange_Filterpanel(newData) {
        this._currentFilterPanelData = newData;

        this.checkDirty();
    }
    private isDirtyFilterpanel: boolean = false;
    private checkDirty(bReset?: boolean) {
        let currentDataStr = null;
        
        if (this._currentFilterPanelData) {
            currentDataStr = JSON.stringify(this._currentFilterPanelData);
        } 
        
        if (bReset === true) {
            this._undirtyDataStr = currentDataStr;
        }

        this.isDirtyFilterpanel = this._undirtyDataStr != currentDataStr && this._filterPanel.valid;
        
        this.UiModder.domClass.toggle(this.sectionFilterPanel, "dirty", this.isDirtyFilterpanel);
        this.disableNode(this.sectionKanbanContainer, this.isDirtyFilterpanel);
        this.btnSubmit.setReadonly(!this.isDirtyFilterpanel);
        this.btnReload.setReadonly((this.isDirtyFilterpanel || !this._currentFilterPanelData) && !!this._filterPanel);

        this._handleCustomButtonsStates();

        //this.btnSubmit.hide(!this.isDirtyFilterpanel);
        //this.btnReload.hide(this.isDirtyFilterpanel || !this._currentFilterPanelData);
        //this.emit("dirty", this.isDirty);
    }

    private _onClick_SubmitFilterpanelValues(evt: MouseEvent) {
        if (this.isDirtyFilterpanel) {
            if (this._currentChangeData) {
                let dlg = new GenericDialog();
                dlg.setup({
                    header: "General_Label_Reload",
                    content: "General_PendingChangesWillBeLost",
                    contentIconClass: toasterIcons.warning,
                    buttonPreset: "okcancel",
                    callback: lang.hitch(this, this.loadKanbanConfig),
                    distinctiveNoCallback: null
                });
            } else {
                this.loadKanbanConfig();
            }
        }
    }
    private _onClick_Reload(evt: MouseEvent) {

        if (this._currentChangeData) {
            let dlg = new GenericDialog();
            dlg.setup({
                header: "General_Label_Reload",
                content: "General_PendingChangesWillBeLost",
                contentIconClass: toasterIcons.warning,
                buttonPreset: "okcancel",
                callback: lang.hitch(this, this._reloadData),
                distinctiveNoCallback: null
            });
        } else {
            this._reloadData();
        }
    }

    private _reloadData() {

        this._onChange_KanbanData(null);

        this.loadKanbanConfig();
    }

    private loadKanbanConfig() {
        this.disableNode(this.filterPanelContainer);

        this._onChange_KanbanData(null);

        if (this._hubConfig.kanbanConfigAPI) {
            let data: any = {};
            if (this._hubConfig.additionalRequestData) {
                if (typeof (this._hubConfig.additionalRequestData) == "object") {
                    data = { ...this._hubConfig.additionalRequestData };
                }
            }

            if (this._currentFilterPanelData) {
                data.filterpanelValues = this._currentFilterPanelData;
            }

            this.StandbyStart();

            this.filterpanelRequest = this.RequestManager.callfunction(
                this._hubConfig.kanbanConfigAPI,
                data,
                lang.hitch(this, this._onLoadKanbanConfigResponse),
                lang.hitch(this, this._onLoadKanbanConfigError)
            );
        }
    }
    private _onLoadKanbanConfigError(error: more.requestErrorMessage) {
        this.StandbyStop();
        alert(error.Message);

        this.disableNode(this.filterPanelContainer, false);
    }

    private _onLoadKanbanConfigResponse(response: KanbanTypes.MainConfig) {
        this.StandbyStop();

        this.checkDirty(true);
        this.disableNode(this.filterPanelContainer, false);


        //if (this._config.dataChangeCallback) {
        //    response.dataChangeCallback = this._config.dataChangeCallback;
        //}

        response.dataChangeCallback = lang.hitch(this, this._onChange_KanbanData);

        if (this._hubConfig.elementDetailsClick) {
            response.showDetailsCallback = this._hubConfig.elementDetailsClick;
        }

        this._previousKanbanConfig = response;
        this.setupKanban(response);
    }

    private _previousKanbanConfig: KanbanTypes.MainConfig;

    private setupKanban(config: KanbanTypes.MainConfig) {
        //Muss geklont werden, da sonst die Elemente byref geändert werden und dadurch beim undo der State nicht zusammenpasst
        let configClone = lang.clone(config);

        if (!config) {
            this.UiModder.domConstruct.empty(this.kanbanContainer);
            return;
        }

        if (!configClone.columns.length || !configClone.dashboards.length) {
            this.hideNode(this.sectionKanbanContainer);
            this.hideNode(this.noResultsContainer, false);
        }

        this.hideNode(this.noResultsContainer);


        if (!this._kanban) {
            this._kanban = new Kanban();
            this._kanban.placeAt(this.kanbanContainer, "only");
        }

        if (this.readonly) configClone.readonly = true;
        if (this._hubConfig.elementEditClick) configClone.editorRequestCallback = this._hubConfig.elementEditClick;
        if (this._hubConfig.editBtnEnabledCallback) configClone.editBtnEnabledCallback = this._hubConfig.editBtnEnabledCallback;

        if (this._hubConfig.infoContentAPI) {

            configClone.infoContentAPI = this._hubConfig.infoContentAPI;
        }

        this.hideNode(this.sectionKanbanContainer, false)

        this._kanban.setup(configClone);
    }

    private _handleCustomButtonsStates() {
        for (let key in this._customButtonsReg) {
            let buttonReg = this._customButtonsReg[key];

            if (buttonReg.overrideEnable === true || buttonReg.overrideEnable === false) {
                buttonReg.button.setReadonly(!buttonReg.overrideEnable);
            } else {

                switch (buttonReg.config.enabled) {
                    case true:
                        buttonReg.button.setReadonly(false);
                        break;

                    case false:
                        buttonReg.button.setReadonly(true);
                        break;

                    case "syncToReload":
                        buttonReg.button.setReadonly(this.btnReload.isReadonly);
                        break;

                    case "syncToSubmit":
                        buttonReg.button.setReadonly(this.btnSubmit.isReadonly);
                        break;
                }
            }
        }
    }

    /**
     * Einen Button auf dauerhaft deaktiviert schalten. Die übliche Konfigurationsregel des Buttons wird übersteuert.
     * @param buttonName
     * @param bLockToDisabled Den Button dauerthaft deaktivieren. Wenn false: Die Übersteuerung wird gelöst.
     */
    disableCustomButton(buttonName: string, bLockToDisabled: boolean) {
        let reg = this._customButtonsReg[buttonName];
        if (reg) {
            reg.overrideEnable = bLockToDisabled == true ? false : null;
        }

        this._handleCustomButtonsStates();
    }
    /**
     * Einen Button auf dauerhaft aktiv schalten. Die übliche Konfigurationsregel des Buttons wird übersteuert.
     * @param buttonName
     * @param bLockToEnabled Den Button dauerthaft aktivieren. Wenn false: Die Übersteuerung wird gelöst.
     */
    enableCustomButton(buttonName: string, bLockToEnabled: boolean) {
        let reg = this._customButtonsReg[buttonName];
        if (reg) {
            reg.overrideEnable = bLockToEnabled == true ? true : null;
        }

        this._handleCustomButtonsStates();
    }
    /**
     * Einen eigenen Button im Hub platzieren (parallel zu Lade- und Neuladebutton)
     * @param internalName
     * @param config
     * @returns
     */
    addCustomButton(internalName: string, config: ButtonConfig) {
        let existingReg = this._customButtonsReg[internalName];
        if (!existingReg) {
            let button = new Button();
            button.setup({
                callback: config.callback,
                label: config.label,
                iconClass: config.iconClass,
                styleClass: "submitBtn secondaryBG",
                parentNode: this._mainButtonsContainer
            });
            
            this._customButtonsReg[internalName] = {
                button: button,
                config: config
            };

            this._handleCustomButtonsStates();
        } else {
            return;
        }
    }

    //BASE
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._customButtonsReg = {};
    }
    startup(): void {
        super.startup.apply(this, arguments as any);


       
    }
}

export default mdsWidget(_KanbanHubBase);